import { baseApi } from "@/core/api/baseApi";
import type {
  NeedsActionListResponse,
  NeedsActionQueryParams,
} from "../../domain/entities/NeedsAction";
import type { NeedsActionListResponseDTO } from "../../domain/dto/NeedsActionDTO";
import { mapNeedsActionListResponseDTO } from "./mappers/needsActionMapper";

export const needsActionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNeedsAction: builder.query<NeedsActionListResponse, NeedsActionQueryParams>({
      query: (params) => {
        const qs = new URLSearchParams();
        if (params.query) qs.append("query", params.query);
        if (params.page) qs.append("page", params.page.toString());
        if (params.page_size) qs.append("page_size", params.page_size.toString());
        if (params.sort_by) qs.append("sort_by", params.sort_by);
        if (params.sort_order) qs.append("sort_order", params.sort_order);
        const queryString = qs.toString();
        return {
          url: `/patients/needs-action${queryString ? `?${queryString}` : ""}`,
          method: "GET",
        };
      },
      transformResponse: (response: NeedsActionListResponseDTO): NeedsActionListResponse =>
        mapNeedsActionListResponseDTO(response),
      providesTags: [{ type: "Patients", id: "NEEDS_ACTION" }],
    }),
  }),
});

export const { useGetNeedsActionQuery } = needsActionApi;
